import { z } from 'zod';
export const CardLinkSchema = z.object({
    id: z.string().min(1),
    type: z.string().min(1).max(50),
    label: z.string().max(100),
    value: z.string().max(500),
    icon: z.string().max(100).optional(),
});
export const CardDataSchema = z.object({
    firstName: z.string().max(100).optional(),
    lastName: z.string().max(100).optional(),
    jobTitle: z.string().max(150).optional(),
    company: z.string().max(150).optional(),
    bio: z.string().max(1000).optional(),
    email: z.string().email().max(254).optional().or(z.literal('')),
    phone: z.string().max(30).optional(),
    phone2: z.string().max(30).optional(),
    website: z.string().url().max(500).optional().or(z.literal('')),
    address: z
        .object({
        street: z.string().max(200).optional(),
        postalCode: z.string().max(20).optional(),
        city: z.string().max(100).optional(),
        country: z.string().max(100).optional(),
    })
        .optional(),
    links: z.array(CardLinkSchema).max(20).optional(),
    avatar: z.string().max(500).optional(),
    banner: z.string().max(500).optional(),
    theme: z
        .object({
        variant: z.string().max(50).optional(),
        colors: z.record(z.string().max(50)).optional(),
        gradient: z.boolean().optional(),
        customAccent: z.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
        font: z.enum(['serif', 'rounded', 'mono']).optional(),
    })
        .optional(),
    privacy: z
        .object({
        requireInteraction: z.boolean().optional(),
        obfuscate: z.boolean().optional(),
        blockRobots: z.boolean().optional(),
    })
        .optional(),
});
/**
 * Optional card data sent with the registration (from the demo editor or the free vCard generator).
 * Only sizes are bounded; the API sanitises the data again when the card is created after e-mail verification.
 */
export const PendingCardSchema = z.object({
    firstName: z.string().max(100).optional(),
    lastName: z.string().max(100).optional(),
    title: z.string().max(150).optional(),
    company: z.string().max(150).optional(),
    email: z.string().max(254).optional(),
    phone: z.string().max(50).optional(),
    phoneSecondary: z.string().max(50).optional(),
    website: z.string().max(500).optional(),
    street: z.string().max(150).optional(),
    postalCode: z.string().max(20).optional(),
    city: z.string().max(100).optional(),
    country: z.string().max(100).optional(),
});
export const RegisterSchema = z.object({
    email: z.string().email().max(254),
    password: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .max(128),
    organisationName: z.string().min(2).max(100),
    termsAccepted: z.literal(true, {
        errorMap: () => ({ message: 'You must accept the terms of service' }),
    }),
    card: PendingCardSchema.optional(),
    /** UI language of the website at sign-up (used for e-mails) */
    locale: z.string().max(10).optional(),
});
//# sourceMappingURL=cardSchema.js.map